import ApiRequest from "./ApiRequest";
import sha256 from 'crypto-js/sha256';

export const currentRates = () => {
    return new Promise(async (resolve, reject) => {
        try {
            const storageHash = sha256(`currency`).toString();
            const currencies = JSON.parse(sessionStorage.getItem(storageHash));
            if (currencies) {
                resolve(currencies);
            } else {
                const result = await ApiRequest.post('get_currency');
                sessionStorage.setItem(storageHash, JSON.stringify(result.data));
                resolve(result.data);
            }
        } catch (error) {
            reject(error.response);
        }
    });
}

export const getTopNumbersPerSeller = (provider = 'jawwal') => {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await ApiRequest.post('get_top_numbers_per_seller', { provider });
            if (result.data && result.data.status === 'success') {
                resolve(result.data.data);
            } else {
                resolve([]);
            }
        } catch (error) {
            console.error('Error fetching top numbers:', error);
            resolve([]);
        }
    });
}